export default function AppSection() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-950">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto flex flex-col lg:flex-row items-center gap-10">
          {/* Left: phone mockup */}
          <div className="flex-shrink-0 w-48 md:w-56 h-auto">
            <div className="relative w-full aspect-[9/16] bg-background-800 rounded-2xl overflow-hidden border-2 border-background-700">
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20screen%20mockup%20showing%20a%20dark%20theme%20news%20feed%20app%20interface%20with%20card%20layouts%2C%20warm%20accent%20colors%2C%20gossip%20and%20entertainment%20news%20style%2C%20modern%20minimal%20UI%20design%2C%20Chinese%20language%20text%20placeholders%2C%20clean%20typography%2C%20mobile%20app%20aesthetic&width=600&height=1066&seq=app-mockup-hl&orientation=portrait"
                alt="黑料APP移动端界面展示"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Right: text */}
          <div className="flex-1 text-center lg:text-left">
            <span className="inline-block text-xs font-semibold bg-accent-500 text-background-950 px-3 py-1.5 rounded-full mb-4 tracking-wide">
              📱 黑料APP
            </span>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50 leading-tight">
              随时随地 · 黑料吃瓜不打烊
            </h2>
            <p className="mt-4 text-sm leading-relaxed text-background-300 max-w-md mx-auto lg:mx-0">
              下载黑料APP，第一时间接收黑料最新爆料推送。无论是通勤路上还是午休间隙，打开APP即可浏览黑料吃瓜在线观看视频和吃瓜黑料合集，不错过任何一条猛料。
            </p>
            <div className="mt-6 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-background-50 text-foreground-950 font-semibold text-sm rounded-lg hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-apple-fill text-lg"></i>
                App Store
              </button>
              <button className="inline-flex items-center gap-2 px-6 py-3 bg-accent-500 text-background-950 font-semibold text-sm rounded-lg hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer">
                <i className="ri-android-fill text-lg"></i>
                Android 下载
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}